import { AutogrowDirective } from './autogrow.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrettyPrintPipe } from './pretty-print.pipe';
import { ContenteditablePlaceholderDirective } from './contenteditable-placeholder.directive';

@NgModule({
  imports: [CommonModule, AutogrowDirective, PrettyPrintPipe, ContenteditablePlaceholderDirective],
  exports: [AutogrowDirective, PrettyPrintPipe, ContenteditablePlaceholderDirective],
})
export class HelpersModule {}
